module.exports = __webpack_public_path__ + "assets/img/modelo_feed_com_logo.73a5817b.png";